/**
 * Error types thrown by the plugin registry and deploy resolution.
 *
 * Each carries a stable `.name` so callers can branch on identity without
 * importing the class (cross-package / cross-bundle `instanceof` is unreliable).
 */

/** Thrown by `register()` when a target id is already registered for its kind. */
export class RegistrationError extends Error {
  constructor(kind: string, id: string) {
    super(`A "${kind}" target with id "${id}" is already registered.`);
    this.name = "RegistrationError";
  }
}

/** Thrown when a lookup by id finds no registered target for the given kind. */
export class MissingTargetError extends Error {
  constructor(kind: string, id: string) {
    super(`No "${kind}" target registered with id "${id}".`);
    this.name = "MissingTargetError";
  }
}

/** Thrown by `register()` when a target declares an unsupported `apiVersion`. */
export class ApiVersionMismatchError extends Error {
  constructor(kind: string, id: string, got: unknown) {
    super(
      `Target "${id}" (kind "${kind}") declares apiVersion ${String(got)}; registry requires apiVersion 1.`,
    );
    this.name = "ApiVersionMismatchError";
  }
}

/** Thrown by `resolveDeployTarget()` when the requested deploy target id is unknown. */
export class DeployTargetNotFoundError extends Error {
  constructor(id: string) {
    super(`No deploy target registered with id "${id}".`);
    this.name = "DeployTargetNotFoundError";
  }
}
